export default {"src":"/_next/static/media/AUR.12d7cc63.svg","height":18,"width":18};